export const SERVICE_ORDER = [
  "reclamevideos",
  "website-analyses",
  "systemen-bouwen",
  "conversiegerichte-websites",
  "leadopvolging",
  "b2b-integraties",
];

export const SERVICES = {
  "reclamevideos": {
    nl: {
      num: "01",
      title: "Reclamevideo's + Ads",
      tagline: "Wij filmen en editen een promotievideo voor jouw bedrijf en zetten die in als betaalde advertentie, precies daar waar jouw doelgroep zit.",
      intro: "Voor lokale bedrijven zoals kappers, salons, barbers en horeca die meer aanvragen willen, en voor B2B-bedrijven die klaar zijn om te schalen.",
      audiences: ["Kappers & barbers", "Salons", "Horeca", "Lokale dienstverleners", "B2B"],
      problemTitle: "Herkenbaar?",
      problemText: "Je levert goed werk, maar online blijft het te stil. Organisch posten levert weinig bereik op en advertenties zonder sterke video converteren niet. Ondertussen loopt de concurrent die wél zichtbaar is met de klanten weg.",
      problemPoints: [
        "Weinig bereik met organische posts",
        "Advertenties zonder overtuigende video",
        "Je doelgroep weet niet dat je bestaat",
      ],
      stepsTitle: "Zo ziet het proces eruit",
      steps: [
        { title: "Kennismaking en strategie", text: "We bespreken je aanbod, je doelgroep en waar die zich bevindt. Daar kiezen we het kanaal bij: Meta, TikTok, Google of LinkedIn." },
        { title: "Concept en script", text: "Wij bedenken het concept en schrijven het script. Jij hoeft het alleen goed te keuren." },
        { title: "Filmdag op locatie", text: "Wij komen langs en filmen alles in één efficiënte sessie, zonder dat het jouw dag verstoort." },
        { title: "Edit en feedback", text: "We monteren de video en leveren korte varianten voor advertenties. Jij geeft feedback, wij perfectioneren." },
        { title: "Campagne live", text: "We zetten de video in als betaalde advertentie en richten de campagne volledig voor je in." },
        { title: "Optimaliseren", text: "We meten wat werkt en sturen continu bij, zodat elke euro meer oplevert." },
      ],
      deliverablesTitle: "Wat je concreet krijgt",
      deliverables: [
        { title: "Professionele promotievideo", text: "Een hoofdvideo plus korte varianten, geoptimaliseerd voor elk advertentiekanaal." },
        { title: "Campagnes die draaien", text: "Volledig ingerichte advertentiecampagnes op het kanaal dat bij jouw doelgroep past." },
        { title: "Doorlopende optimalisatie", text: "Wij sturen bij op basis van data. Jij ziet de aanvragen binnenkomen." },
        { title: "Helder overzicht", text: "Je ziet precies wat de campagne oplevert, in begrijpelijke taal." },
      ],
      whyTitle: "Waarom 4thscenery",
      whyPoints: [
        "Video en targeting onder één dak, zonder dure tussenlagen",
        "Wij testen alles eerst binnen ons eigen bedrijf voordat het bij jou draait",
        "Focus op aanvragen en omzet, niet op likes",
        "Geen organische-content-fluff als leidend verhaal: betaalde advertenties die schalen",
      ],
      ctaTitle: "Klaar om zichtbaar te worden?",
      ctaText: "Plan een gratis kennismaking van 15 minuten. Wij kijken direct met je mee wat video-adverteren voor jouw bedrijf kan betekenen.",
      meta: {
        title: "Reclamevideo's + Ads · 4thscenery",
        description: "Wij filmen en editen een promotievideo voor jouw bedrijf en zetten die in als betaalde advertentie op Meta, TikTok, Google of LinkedIn. Meer zichtbaarheid, meer aanvragen.",
      },
    },
    en: {
      num: "01",
      title: "Promo videos + Ads",
      tagline: "We film and edit a promo video for your business and run it as a paid ad, exactly where your audience is.",
      intro: "For local businesses like barbers, salons and hospitality that want more enquiries, and for B2B companies ready to scale.",
      audiences: ["Barbers", "Salons", "Hospitality", "Local services", "B2B"],
      problemTitle: "Sound familiar?",
      problemText: "You do great work, but online it stays too quiet. Organic posting barely reaches anyone and ads without a strong video do not convert. Meanwhile the competitor who is visible walks away with the customers.",
      problemPoints: [
        "Little reach with organic posts",
        "Ads without a convincing video",
        "Your audience does not know you exist",
      ],
      stepsTitle: "What the process looks like",
      steps: [
        { title: "Intro and strategy", text: "We discuss your offer, your audience and where they spend time. That decides the channel: Meta, TikTok, Google or LinkedIn." },
        { title: "Concept and script", text: "We create the concept and write the script. You only have to approve it." },
        { title: "Filming on location", text: "We come by and film everything in one efficient session, without disrupting your day." },
        { title: "Edit and feedback", text: "We edit the video and deliver short ad variants. You give feedback, we perfect it." },
        { title: "Campaign live", text: "We run the video as a paid ad and set up the entire campaign for you." },
        { title: "Optimising", text: "We measure what works and keep adjusting, so every euro delivers more." },
      ],
      deliverablesTitle: "What you get",
      deliverables: [
        { title: "Professional promo video", text: "A main video plus short variants, optimised for every ad channel." },
        { title: "Campaigns that run", text: "Fully set-up ad campaigns on the channel that fits your audience." },
        { title: "Ongoing optimisation", text: "We adjust based on data. You watch the enquiries come in." },
        { title: "Clear reporting", text: "You see exactly what the campaign delivers, in plain language." },
      ],
      whyTitle: "Why 4thscenery",
      whyPoints: [
        "Video and targeting under one roof, no expensive middlemen",
        "We test everything inside our own company first",
        "Focused on enquiries and revenue, not on likes",
        "No organic-content fluff as the lead story: paid ads that scale",
      ],
      ctaTitle: "Ready to become visible?",
      ctaText: "Book a free 15-minute intro call. We will look at what video advertising could mean for your business right away.",
      meta: {
        title: "Promo videos + Ads · 4thscenery",
        description: "We film and edit a promo video for your business and run it as a paid ad on Meta, TikTok, Google or LinkedIn. More visibility, more enquiries.",
      },
    },
  },
  "website-analyses": {
    nl: {
      num: "02",
      title: "Website-analyses",
      tagline: "Een scherpe audit van je website: wat werkt, wat kost je klanten en wat we direct verbeteren.",
      intro: "Voor lokale bedrijven en B2B-organisaties die al bezoekers op hun site hebben, maar er te weinig aanvragen of boekingen uithalen.",
      audiences: ["Kappers & barbers", "Salons", "Horeca", "B2B"],
      problemTitle: "Herkenbaar?",
      problemText: "Je hebt een website en er komt verkeer op, maar het blijft stil. Bezoekers haken af omdat je aanbod niet direct duidelijk is, de site traag laadt of de volgende stap ontbreekt.",
      problemPoints: [
        "Bezoekers haken af zonder contact op te nemen",
        "Je aanbod is niet meteen duidelijk",
        "Geen duidelijke call-to-action",
        "Techniek en snelheid kosten je klanten",
      ],
      stepsTitle: "Zo ziet het proces eruit",
      steps: [
        { title: "Je deelt je website", text: "Wij hebben alleen je link nodig. Geen lange intake, geen formulierenmarathon." },
        { title: "Wij analyseren alles", text: "Conversie, UX, snelheid en hoe helder je aanbod overkomt. Alles leggen we langs de lat." },
        { title: "Concreet verbeterplan", text: "Je ontvangt een plan met quick wins en structurele verbeteringen, op volgorde van impact." },
        { title: "Doorgeven of uitvoeren", text: "We bespreken het plan samen. Daarna voer je het zelf uit of laat je het aan ons over." },
      ],
      deliverablesTitle: "Wat je concreet krijgt",
      deliverables: [
        { title: "Audit in begrijpelijke taal", text: "Geen vaag rapport van vijftig pagina's, maar een helder document met wat er echt toe doet." },
        { title: "Geprioriteerde verbeterlijst", text: "Quick wins bovenaan, structurele punten eronder. Je weet precies waar je begint." },
        { title: "Doorspreeksessie", text: "We lopen de bevindingen samen door en beantwoorden al je vragen." },
      ],
      whyTitle: "Waarom 4thscenery",
      whyPoints: [
        "Wij bouwen zelf conversiegerichte websites en weten daardoor wat werkt",
        "Een concreet plan in plaats van een vaag rapport",
        "Ook de uitvoering kunnen we direct voor je oppakken",
        "Eerlijk advies, ook als er verrassend weinig mis is",
      ],
      ctaTitle: "Wil je weten wat je website je kost?",
      ctaText: "Vraag een analyse aan tijdens een gratis kennismaking van 15 minuten. Je loopt altijd weg met een volgende stap.",
      meta: {
        title: "Website-analyses · 4thscenery",
        description: "Scherpe audit van je website: wat werkt, wat kost je klanten en wat je direct kunt verbeteren. Een concreet plan, geen vaag rapport.",
      },
    },
    en: {
      num: "02",
      title: "Website audits",
      tagline: "A sharp audit of your website: what works, what is costing you customers and what we would improve right away.",
      intro: "For local businesses and B2B organisations that already get traffic, but too few enquiries or bookings out of it.",
      audiences: ["Barbers", "Salons", "Hospitality", "B2B"],
      problemTitle: "Sound familiar?",
      problemText: "You have a website and people visit it, but it stays quiet. Visitors drop off because your offer is not immediately clear, the site loads slowly or the next step is missing.",
      problemPoints: [
        "Visitors leave without getting in touch",
        "Your offer is not clear at first glance",
        "No clear call to action",
        "Tech and speed are costing you customers",
      ],
      stepsTitle: "What the process looks like",
      steps: [
        { title: "You share your website", text: "All we need is your link. No long intake, no form marathon." },
        { title: "We analyse everything", text: "Conversion, UX, speed and how clearly your offer comes across. We check it all." },
        { title: "Concrete improvement plan", text: "You receive a plan with quick wins and structural improvements, ordered by impact." },
        { title: "Hand over or execute", text: "We walk through the plan together. Then you execute it yourself or leave it to us." },
      ],
      deliverablesTitle: "What you get",
      deliverables: [
        { title: "Audit in plain language", text: "No vague fifty-page report, but a clear document with what actually matters." },
        { title: "Prioritised improvement list", text: "Quick wins first, structural points after. You know exactly where to start." },
        { title: "Walkthrough session", text: "We go through the findings together and answer all your questions." },
      ],
      whyTitle: "Why 4thscenery",
      whyPoints: [
        "We build conversion-focused websites ourselves, so we know what works",
        "A concrete plan instead of a vague report",
        "We can execute the improvements for you right away",
        "Honest advice, even when surprisingly little is wrong",
      ],
      ctaTitle: "Want to know what your website is costing you?",
      ctaText: "Request an audit during a free 15-minute intro call. You will always leave with a next step.",
      meta: {
        title: "Website audits · 4thscenery",
        description: "A sharp audit of your website: what works, what is costing you customers and what to improve right away. A concrete plan, not a vague report.",
      },
    },
  },
  "systemen-bouwen": {
    nl: {
      num: "03",
      title: "Systemen bouwen",
      tagline: "Automatiseringen en tools op maat die je bedrijf laten groeien, ook terwijl jij slaapt.",
      intro: "Voor bedrijven die leads verliezen door gemiste oproepen, te veel handmatig werk hebben of systemen die niet met elkaar praten. Maatwerk per klant, geen standaardpakket.",
      audiences: ["Lokale dienstverleners", "Horeca", "B2B", "Groeiende teams"],
      problemTitle: "Herkenbaar?",
      problemText: "Een gemiste oproep is een gemiste klant. Leads worden te laat opgevolgd en je bestaande software werkt niet samen. Dat kost elke week omzet, zonder dat je het ziet.",
      problemPoints: [
        "Gemiste oproepen worden nooit opgevolgd",
        "Handmatig werk vreet uren",
        "Systemen praten niet met elkaar",
        "Leads koelen af voordat je reageert",
      ],
      stepsTitle: "Zo ziet het proces eruit",
      steps: [
        { title: "Inzicht in je processen", text: "We kijken waar het lekt: welke leads gaan verloren en welke taken kosten onnodig tijd." },
        { title: "Ontwerp op maat", text: "We ontwerpen een systeem dat bij jouw bedrijf past. Bijvoorbeeld een Lead Gen Systeem, maar altijd maatwerk." },
        { title: "Bouw en koppeling", text: "We bouwen het systeem en koppelen het aan je bestaande B2B-software." },
        { title: "Livegang en doorontwikkeling", text: "Het systeem draait en wij blijven verbeteren op basis van wat we in de praktijk zien." },
      ],
      deliverablesTitle: "Wat je concreet krijgt",
      deliverables: [
        { title: "Een maatwerk systeem", text: "Bijvoorbeeld een Lead Gen Systeem: gemiste oproep? Automatische sms. Nieuwe lead? Direct opgevolgd." },
        { title: "Automatische leadopvolging", text: "Via SMS, WhatsApp en e-mail, op het kanaal dat werkt voor jouw klant." },
        { title: "Koppelingen met je software", text: "Complete integraties met je bestaande B2B-tools, zodat alles naadloos samenwerkt." },
        { title: "Een agenda die zichzelf vult", text: "Boekingen en opvolging lopen automatisch door, zonder dat jij ernaar omkijkt." },
      ],
      whyTitle: "Waarom 4thscenery",
      whyPoints: [
        "Wij draaien deze systemen eerst in ons eigen bedrijf voordat ze bij jou draaien",
        "Maatwerk per klant, nooit een vast pakket",
        "Eén team voor strategie, bouw en doorontwikkeling",
        "Resultaat dat je merkt in tijd én omzet",
      ],
      ctaTitle: "Klaar om te automatiseren?",
      ctaText: "Vertel ons waar het bij jou lekt. In een gratis kennismaking van 15 minuten denken we direct met je mee.",
      meta: {
        title: "Systemen bouwen · 4thscenery",
        description: "Automatiseringen en tools op maat: Lead Gen Systemen, automatische leadopvolging en B2B software-integraties die je bedrijf laten groeien.",
      },
    },
    en: {
      num: "03",
      title: "Systems & automation",
      tagline: "Custom automations and tools that grow your business, even while you sleep.",
      intro: "For businesses losing leads to missed calls, drowning in manual work or running systems that do not talk to each other. Custom-built per client, never a fixed package.",
      audiences: ["Local services", "Hospitality", "B2B", "Growing teams"],
      problemTitle: "Sound familiar?",
      problemText: "A missed call is a missed customer. Leads get followed up too late and your existing software does not work together. That costs you revenue every week, without you even seeing it.",
      problemPoints: [
        "Missed calls are never followed up",
        "Manual work eats hours",
        "Systems do not talk to each other",
        "Leads cool down before you respond",
      ],
      stepsTitle: "What the process looks like",
      steps: [
        { title: "Insight into your processes", text: "We look at where it leaks: which leads get lost and which tasks waste time." },
        { title: "Custom design", text: "We design a system that fits your business. A Lead Gen System for example, but always custom work." },
        { title: "Build and connect", text: "We build the system and connect it to your existing B2B software." },
        { title: "Launch and keep improving", text: "The system runs and we keep improving it based on what we see in practice." },
      ],
      deliverablesTitle: "What you get",
      deliverables: [
        { title: "A custom-built system", text: "A Lead Gen System for example: missed call? Automatic text. New lead? Followed up instantly." },
        { title: "Automatic lead follow-up", text: "Via SMS, WhatsApp and email, on the channel that works for your customer." },
        { title: "Integrations with your software", text: "Complete connections with your existing B2B tools, so everything works together seamlessly." },
        { title: "A calendar that fills itself", text: "Bookings and follow-ups keep running automatically, without you thinking about it." },
      ],
      whyTitle: "Why 4thscenery",
      whyPoints: [
        "We run these systems inside our own company before they run at yours",
        "Custom work per client, never a fixed package",
        "One team for strategy, build and ongoing development",
        "Results you notice in time saved and revenue",
      ],
      ctaTitle: "Ready to automate?",
      ctaText: "Tell us where your business leaks. In a free 15-minute intro call we will think along right away.",
      meta: {
        title: "Systems & automation · 4thscenery",
        description: "Custom automations and tools: Lead Gen Systems, automatic lead follow-up and B2B software integrations that grow your business.",
      },
    },
  },
  "conversiegerichte-websites": {
    nl: {
      num: "04",
      title: "Conversiegerichte websites",
      tagline: "Een website die bezoekers omzet in aanvragen. Gebouwd rond één doel: conversie.",
      intro: "Voor bedrijven die meer willen dan een online visitekaartje: een website die dag en nacht actief klanten oplevert.",
      audiences: ["Kappers & barbers", "Salons", "Horeca", "Lokale dienstverleners", "B2B"],
      problemTitle: "Herkenbaar?",
      problemText: "Je website ziet er netjes uit, maar levert niets op. Bezoekers kijken rond en vertrekken zonder te bellen, boeken of mailen. Een mooie site zonder strategie is een verloren investering.",
      problemPoints: [
        "Mooie site, maar geen aanvragen",
        "Bezoekers vinden niet snel wat ze zoeken",
        "Geen duidelijke volgende stap",
        "Gebouwd op gevoel, niet op conversie",
      ],
      stepsTitle: "Zo ziet het proces eruit",
      steps: [
        { title: "Doel en strategie", text: "We bepalen samen wat de website moet opleveren: telefoontjes, boekingen of aanvragen. Daar bouwen we alles omheen." },
        { title: "Structuur en teksten", text: "We ontwerpen de opbouw en schrijven teksten die overtuigen, in de taal van jouw klant." },
        { title: "Design en bouw", text: "Een snel, modern en mobielvriendelijk ontwerp dat past bij je merk en vertrouwen opwekt." },
        { title: "Livegang en meten", text: "De site gaat live en we meten wat bezoekers doen, zodat we blijven verbeteren." },
      ],
      deliverablesTitle: "Wat je concreet krijgt",
      deliverables: [
        { title: "Een website die verkoopt", text: "Elke pagina stuurt bezoekers richting één duidelijke actie: contact opnemen of boeken." },
        { title: "Snel en mobielvriendelijk", text: "Strakke laadtijden en een vloeiende ervaring op elke telefoon, tablet en laptop." },
        { title: "Vindbaar in Google", text: "Technische SEO en een schone structuur, zodat klanten je ook daadwerkelijk vinden." },
        { title: "Makkelijk aan te passen", text: "Teksten, foto's en aanbod pas je eenvoudig aan, zonder developer." },
      ],
      whyTitle: "Waarom 4thscenery",
      whyPoints: [
        "Wij bouwen rond conversie, niet rond mooi",
        "Elke keuze is eerst getest in ons eigen bedrijf",
        "Website, video en automatisering onder één dak",
        "Snelle oplevering zonder eindeloze rondes",
      ],
      ctaTitle: "Klaar voor een website die werkt?",
      ctaText: "Plan een gratis kennismaking van 15 minuten. We bespreken direct wat een conversiegerichte website voor jouw bedrijf kan betekenen.",
      meta: {
        title: "Conversiegerichte websites · 4thscenery",
        description: "Websites die bezoekers omzetten in aanvragen. Snel, vindbaar in Google en gebouwd rond één doel: conversie.",
      },
    },
    en: {
      num: "04",
      title: "Conversion-focused websites",
      tagline: "A website that turns visitors into enquiries. Built around one goal: conversion.",
      intro: "For businesses that want more than an online business card: a website that actively brings in customers, day and night.",
      audiences: ["Barbers", "Salons", "Hospitality", "Local services", "B2B"],
      problemTitle: "Sound familiar?",
      problemText: "Your website looks fine, but delivers nothing. Visitors browse around and leave without calling, booking or emailing. A pretty site without strategy is a wasted investment.",
      problemPoints: [
        "Nice site, but no enquiries",
        "Visitors cannot find what they need",
        "No clear next step",
        "Built on gut feeling, not conversion",
      ],
      stepsTitle: "What the process looks like",
      steps: [
        { title: "Goal and strategy", text: "Together we define what the website must deliver: calls, bookings or enquiries. We build everything around that." },
        { title: "Structure and copy", text: "We design the structure and write copy that convinces, in the language of your customer." },
        { title: "Design and build", text: "A fast, modern and mobile-friendly design that fits your brand and builds trust." },
        { title: "Launch and measure", text: "The site goes live and we measure what visitors do, so we keep improving." },
      ],
      deliverablesTitle: "What you get",
      deliverables: [
        { title: "A website that sells", text: "Every page guides visitors towards one clear action: get in touch or book." },
        { title: "Fast and mobile-friendly", text: "Sharp loading times and a smooth experience on every phone, tablet and laptop." },
        { title: "Found on Google", text: "Technical SEO and a clean structure, so customers actually find you." },
        { title: "Easy to update", text: "Change texts, photos and offers easily, without needing a developer." },
      ],
      whyTitle: "Why 4thscenery",
      whyPoints: [
        "We build for conversion, not for pretty",
        "Every choice is tested inside our own business first",
        "Website, video and automation under one roof",
        "Fast delivery without endless rounds",
      ],
      ctaTitle: "Ready for a website that works?",
      ctaText: "Book a free 15-minute intro call. We will discuss right away what a conversion-focused website could mean for your business.",
      meta: {
        title: "Conversion-focused websites · 4thscenery",
        description: "Websites that turn visitors into enquiries. Fast, findable on Google and built around one goal: conversion.",
      },
    },
  },
  "leadopvolging": {
    nl: {
      num: "05",
      title: "Leadopvolging via SMS, WhatsApp & e-mail",
      tagline: "Elke lead wordt binnen seconden automatisch opgevolgd, op het kanaal dat werkt voor jouw klant.",
      intro: "Voor bedrijven die aanvragen binnenkrijgen maar er te laat of helemaal niet op reageren, en zo elke week omzet laten liggen.",
      audiences: ["Lokale dienstverleners", "Horeca", "Salons", "B2B"],
      problemTitle: "Herkenbaar?",
      problemText: "De meeste leads kiezen de partij die als eerste reageert. Wie uren later terugbelt of mailt, is vaak al te laat. En een gemiste oproep zonder opvolging is gegarandeerd een gemiste klant.",
      problemPoints: [
        "Gemiste oproepen krijgen geen vervolg",
        "Reacties op aanvragen duren te lang",
        "Leads verspreid over mail, app en DM's",
        "Niemand weet welke lead nog opgevolgd moet worden",
      ],
      stepsTitle: "Zo ziet het proces eruit",
      steps: [
        { title: "Kanalen in kaart", text: "We brengen in beeld waar jouw leads binnenkomen: telefoon, WhatsApp, e-mail, formulieren en social." },
        { title: "Opvolgstromen ontwerpen", text: "Per kanaal ontwerpen we een automatische reactie die past bij jouw toon en aanbod." },
        { title: "Inrichten en koppelen", text: "We zetten de automatiseringen op en koppelen ze aan je agenda en bestaande software." },
        { title: "Testen en aanscherpen", text: "We testen elke flow met echte scenario's en blijven teksten en timing verbeteren." },
      ],
      deliverablesTitle: "Wat je concreet krijgt",
      deliverables: [
        { title: "Gemiste oproep? Direct een sms", text: "Kan je niet opnemen, dan krijgt de beller binnen seconden automatisch een bericht terug." },
        { title: "Opvolging op elk kanaal", text: "Automatisch via SMS, WhatsApp en e-mail, afgestemd op waar jouw klant actief is." },
        { title: "Direct door naar je agenda", text: "Leads plannen zelf een gesprek of boeking in, zonder heen-en-weer." },
        { title: "Overzicht van elke lead", text: "Je ziet precies welke aanvraag wanneer is opgevolgd, zodat niets verloren gaat." },
      ],
      whyTitle: "Waarom 4thscenery",
      whyPoints: [
        "Dit systeem draait vandaag nog in ons eigen bedrijf",
        "Opvolging binnen seconden, niet binnen uren",
        "Werkt samen met je bestaande tools",
        "Meetbaar resultaat: meer gesprekken uit dezelfde leads",
      ],
      ctaTitle: "Klaar om geen lead meer te missen?",
      ctaText: "Plan een gratis kennismaking van 15 minuten. We laten je direct zien hoe automatische opvolging er voor jouw bedrijf uitziet.",
      meta: {
        title: "Leadopvolging via SMS, WhatsApp & e-mail · 4thscenery",
        description: "Elke lead binnen seconden automatisch opgevolgd via SMS, WhatsApp en e-mail. Gemiste oproep? Direct een bericht terug.",
      },
    },
    en: {
      num: "05",
      title: "Lead follow-up via SMS, WhatsApp & email",
      tagline: "Every lead is followed up automatically within seconds, on the channel that works for your customer.",
      intro: "For businesses that receive enquiries but respond too late or not at all, leaving revenue on the table every week.",
      audiences: ["Local services", "Hospitality", "Salons", "B2B"],
      problemTitle: "Sound familiar?",
      problemText: "Most leads choose the party that responds first. Call or email back hours later and you are often too late. And a missed call without follow-up is a guaranteed missed customer.",
      problemPoints: [
        "Missed calls get no follow-up",
        "Responses to enquiries take too long",
        "Leads scattered across email, WhatsApp and DMs",
        "Nobody knows which lead still needs follow-up",
      ],
      stepsTitle: "What the process looks like",
      steps: [
        { title: "Map your channels", text: "We map where your leads come in: phone, WhatsApp, email, forms and social." },
        { title: "Design follow-up flows", text: "Per channel we design an automatic response that fits your tone and offer." },
        { title: "Set up and connect", text: "We set up the automations and connect them to your calendar and existing software." },
        { title: "Test and sharpen", text: "We test every flow with real scenarios and keep improving copy and timing." },
      ],
      deliverablesTitle: "What you get",
      deliverables: [
        { title: "Missed call? Instant text back", text: "If you cannot pick up, the caller automatically gets a message back within seconds." },
        { title: "Follow-up on every channel", text: "Automatically via SMS, WhatsApp and email, matched to where your customer is active." },
        { title: "Straight into your calendar", text: "Leads book a call or appointment themselves, without back-and-forth." },
        { title: "Overview of every lead", text: "You see exactly which enquiry was followed up when, so nothing gets lost." },
      ],
      whyTitle: "Why 4thscenery",
      whyPoints: [
        "This system runs inside our own business today",
        "Follow-up within seconds, not hours",
        "Works with your existing tools",
        "Measurable result: more calls from the same leads",
      ],
      ctaTitle: "Ready to never miss a lead again?",
      ctaText: "Book a free 15-minute intro call. We will show you right away what automatic follow-up looks like for your business.",
      meta: {
        title: "Lead follow-up via SMS, WhatsApp & email · 4thscenery",
        description: "Every lead followed up automatically within seconds via SMS, WhatsApp and email. Missed call? Instant message back.",
      },
    },
  },
  "b2b-integraties": {
    nl: {
      num: "06",
      title: "B2B software-integraties",
      tagline: "Complete koppelingen tussen je bestaande software, zodat je systemen naadloos samenwerken en handmatig werk verdwijnt.",
      intro: "Voor bedrijven met meerdere tools die niet met elkaar praten: CRM, boekhouding, agenda's, webshop en meer.",
      audiences: ["B2B", "Groeiende teams", "Lokale dienstverleners", "Webshops"],
      problemTitle: "Herkenbaar?",
      problemText: "Je CRM kent je agenda niet, je boekhouding kent je webshop niet en tussendoor typ jij alles handmatig over. Elke koppeling die ontbreekt kost uren per week en levert fouten op.",
      problemPoints: [
        "Data handmatig overtypen tussen systemen",
        "Fouten door dubbele invoer",
        "Tools die niet met elkaar praten",
        "Groei remt omdat processen niet meeschalen",
      ],
      stepsTitle: "Zo ziet het proces eruit",
      steps: [
        { title: "Landschap in kaart", text: "We brengen al je software en processen in beeld en vinden waar handmatig werk en fouten ontstaan." },
        { title: "Koppelplan op maat", text: "We bepalen welke integraties de meeste tijd en omzet opleveren, op volgorde van impact." },
        { title: "Bouw en testen", text: "We bouwen de koppelingen en testen ze grondig met echte data voordat er iets live gaat." },
        { title: "Livegang en beheer", text: "De integraties draaien en wij blijven monitoren en doorontwikkelen waar nodig." },
      ],
      deliverablesTitle: "Wat je concreet krijgt",
      deliverables: [
        { title: "Systemen die samenwerken", text: "CRM, agenda, boekhouding en webshop praten automatisch met elkaar." },
        { title: "Minder handmatig werk", text: "Gegevens stromen automatisch door, zonder overtypen en zonder invoerfouten." },
        { title: "Eén waarheid in je data", text: "Elke afdeling kijkt naar dezelfde actuele cijfers en klantgegevens." },
        { title: "Klaar voor groei", text: "Processen schalen mee zonder dat je meer mensen hoeft aan te nemen." },
      ],
      whyTitle: "Waarom 4thscenery",
      whyPoints: [
        "Wij bouwen eerst binnen ons eigen bedrijf voordat iets bij jou draait",
        "Eén team voor analyse, bouw en beheer",
        "Maatwerk in plaats van dure standaardlicenties",
        "Resultaat dat je merkt in uren én fouten",
      ],
      ctaTitle: "Klaar om je systemen te verbinden?",
      ctaText: "Vertel ons welke tools je gebruikt. In een gratis kennismaking van 15 minuten laten we zien welke koppelingen het meeste opleveren.",
      meta: {
        title: "B2B software-integraties · 4thscenery",
        description: "Complete koppelingen met je bestaande B2B-software. Minder handmatig werk, minder fouten en systemen die naadloos samenwerken.",
      },
    },
    en: {
      num: "06",
      title: "B2B software integrations",
      tagline: "Complete connections between your existing software, so your systems work together seamlessly and manual work disappears.",
      intro: "For businesses running multiple tools that do not talk to each other: CRM, accounting, calendars, webshop and more.",
      audiences: ["B2B", "Growing teams", "Local services", "Webshops"],
      problemTitle: "Sound familiar?",
      problemText: "Your CRM does not know your calendar, your accounting does not know your webshop, and in between you retype everything by hand. Every missing connection costs hours per week and creates errors.",
      problemPoints: [
        "Manually copying data between systems",
        "Errors from double entry",
        "Tools that do not talk to each other",
        "Growth stalls because processes do not scale",
      ],
      stepsTitle: "What the process looks like",
      steps: [
        { title: "Map the landscape", text: "We map all your software and processes and find where manual work and errors appear." },
        { title: "Custom connection plan", text: "We decide which integrations deliver the most time and revenue, ordered by impact." },
        { title: "Build and test", text: "We build the connections and test them thoroughly with real data before anything goes live." },
        { title: "Launch and manage", text: "The integrations run and we keep monitoring and improving where needed." },
      ],
      deliverablesTitle: "What you get",
      deliverables: [
        { title: "Systems that work together", text: "CRM, calendar, accounting and webshop talk to each other automatically." },
        { title: "Less manual work", text: "Data flows automatically, without retyping and without input errors." },
        { title: "One truth in your data", text: "Every team looks at the same up-to-date numbers and customer details." },
        { title: "Ready for growth", text: "Processes scale without needing to hire more people." },
      ],
      whyTitle: "Why 4thscenery",
      whyPoints: [
        "We build inside our own business before anything runs at yours",
        "One team for analysis, build and management",
        "Custom work instead of expensive standard licences",
        "Results you notice in hours saved and errors avoided",
      ],
      ctaTitle: "Ready to connect your systems?",
      ctaText: "Tell us which tools you use. In a free 15-minute intro call we will show you which connections deliver the most.",
      meta: {
        title: "B2B software integrations · 4thscenery",
        description: "Complete connections with your existing B2B software. Less manual work, fewer errors and systems that work together seamlessly.",
      },
    },
  },
};

export const SERVICE_IMAGES = {
  "reclamevideos": {
    src: "/media/svc-reclamevideos.jpg",
    altNl: "Videograaf aan het filmen met een professionele camera",
    altEn: "Videographer filming with a professional camera",
  },
  "website-analyses": {
    src: "/media/svc-website-analyses.jpg",
    altNl: "Laptop met een analytisch dashboard vol grafieken",
    altEn: "Laptop showing an analytics dashboard full of charts",
  },
  "systemen-bouwen": {
    src: "/media/svc-systemen-bouwen.jpg",
    altNl: "Close-up van een printplaat met elektronische componenten",
    altEn: "Close-up of a circuit board with electronic components",
  },
  "conversiegerichte-websites": {
    src: "/media/svc-conversiegerichte-websites.jpg",
    altNl: "Laptop waarop een website wordt ontworpen",
    altEn: "Laptop with a website being designed",
  },
  "leadopvolging": {
    src: "/media/svc-leadopvolging.jpg",
    altNl: "Hand met een smartphone vol binnengekomen meldingen",
    altEn: "Hand holding a smartphone full of incoming notifications",
  },
  "b2b-integraties": {
    src: "/media/svc-b2b-integraties.jpg",
    altNl: "Serverruimte met netwerkkabels die systemen verbinden",
    altEn: "Server room with network cables connecting systems",
  },
};

export const OVERVIEW = {
  nl: {
    eyebrow: "Diensten",
    title: "Zes diensten, één doel: groei",
    intro: "Alles bij 4thscenery draait om één ding: marketing die klanten oplevert, niet alleen bereik. Kies de dienst die past bij waar jij nu staat.",
    cardCta: "Bekijk deze dienst",
    extraTitle: "Twijfel je waar je moet beginnen?",
    extraText: "Plan een gratis kennismaking van 15 minuten. We kijken samen welke dienst op dit moment het meeste oplevert voor jouw bedrijf.",
    extraCta: "Plan een gratis kennismaking",
    meta: {
      title: "Diensten · 4thscenery",
      description: "Reclamevideo's + ads, website-analyses, systemen bouwen, conversiegerichte websites, leadopvolging en B2B software-integraties. Marketing die klanten oplevert.",
    },
  },
  en: {
    eyebrow: "Services",
    title: "Six services, one goal: growth",
    intro: "Everything at 4thscenery revolves around one thing: marketing that brings in customers, not just reach. Pick the service that fits where you are now.",
    cardCta: "View this service",
    extraTitle: "Not sure where to start?",
    extraText: "Book a free 15-minute intro call. Together we will look at which service delivers the most for your business right now.",
    extraCta: "Book a free intro call",
    meta: {
      title: "Services · 4thscenery",
      description: "Promo videos + ads, website audits, custom systems, conversion-focused websites, lead follow-up and B2B software integrations. Marketing that brings in customers.",
    },
  },
};
